import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";



import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function FuelLab(props) {
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const { globalfilter, screen, updateParent, reset, type } = props;
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [formObj, setFormObj] = useState(FilterObj);
    const [FuelLabData, setFuelLabData] = React.useState([]);
    const [filteredString, setValue] = useState("");
    const fetchFuelLabNameData = async (event) => {
        //
        const searchStr = event.target.value;
        setValue(searchStr);
        let customerKey = localStorage.getItem("currentpagecustomer");
        let vesselKey = localStorage.getItem("currentshipnameimo");
        if (customerKey == "") {
            customerKey = null;
        }
        if (vesselKey == "") {
            vesselKey = null
        }
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/FuelLab/${customerKey}/${vesselKey}`;/*${searchStr}`;*/

        await getRequest(url)
            .then((res) => {
                console.log("Responce", res);
                if (res.status == 200) {
                    //let obj = { "axContractId": "All" };

                    let data = res.data;
                    let result = data?.map((a, i) => {
                        return { id: a?.id, name: a?.title };
                    });
                    /*  if (selectedvalue) {
                         selectedvalue.forEach((val, i) => {
                             result = result.filter((ele) => ele.name != val.name)
                         })
                     } */
                    setFuelLabData(result);
                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                // dispatch({ type: LOADING, payload: false });
                //console.log(error);
                // ToastError(error.response.data.message);
            });
           
    }
    const handleChange = (event, newValue) => {
        //
        props.onChange(newValue);
        const filteredFuelLab = {
            ...formObj,
            Fqtlab: newValue
        };
        setFormObj(filteredFuelLab);
        setselectedvalue(newValue);
        setValue("");
        let selectedFqtLabkey = newValue.map((i, v) => i.id).join(",");
        localStorage.setItem("currentFqtLabkey", selectedFqtLabkey);
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
            Obj = {
                ...Obj,
                Fqtlab: newValue
            }
            localStorage.setItem("FilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        //
        let filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                Fqtlab: filtervalue.Fqtlab
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.Fqtlab);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.Fqtlab);
            console.log('getcookievalue', formObj)
        } else {
            setFormObj({});
        }

    }
    React.useEffect(() => {
        //
        if (reset > 0)
            defaultValue(GlobalFilterSettingValue);

    }, [reset]);
    React.useEffect(() => {
        //
        defaultValue(GlobalFilterSettingValue);
        //fetchFuelLabNameData();
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj.Fqtlab || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={FuelLabData}
                getOptionLabel={(option) => option.name}

                onChange={(event, newValue) => handleChange(event, newValue)}
                inputValue={filteredString}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Laboratory"
                        placeholder=""
                        onChange={fetchFuelLabNameData}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

